import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
// import NightLifeSidebar from "../../layouts/NightLifeSidebar";
import AdminSidebar from "../../layouts/AdminSidebar";
import { useSelector } from "react-redux";
import webServices from "../../../services/webServices";
import AppConstants from "../../../appConstants";
import NightLifeVenueDetailsComp from "../../common/NightLifeVenueDetailsComp";
import { authCall } from "../../../services";

const buttons = [
  {
    id: 1,
    label: "Update",
  },
];

const buttonsForMenu = [
  {
    id: 1,
    label: "Update",
  },
];

function UpdateNightlifeVenueDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const { nightlifeId, actiontype } = location.state || {};
  const [companyDetails, setCompanyDetails] = useState(false);
  const { current } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!nightlifeId) {
      navigate(AppConstants.routes.admin.nightlifeEditListing);
    }

    async function fetchData() {
      const resp = await authCall("getCompanyDetails", {
        companyId: nightlifeId,
        companyType: "Bar",
      });
      if (resp?.type === "success") {
        setCompanyDetails(resp?.payload);
      }
    }
    fetchData();
  }, []);

  const handleSubmitForm = async (data) => {
    setLoading(true);
    const resp = await webServices.createNightLife({
      ...data,
      nightLifeId: companyDetails?.id,
    });
    if (resp?.type === "success") {
      setLoading(false);
      toast.dismiss();

      toast.success("Updated successfully.");
      if (current?.user_type === "Admin") {
        if (!actiontype) {
          navigate(AppConstants.routes.admin.nightLifeList);
        } else {
          navigate(`${AppConstants.routes.admin.tags}?type=${actiontype}`);
        }
      } else {
        navigate(AppConstants.routes.admin.nightlifeEditListing);
      }
    }
  };

  return (
    <>
      <NightLifeVenueDetailsComp
        onSubmit={handleSubmitForm}
        loading={loading}
        details={companyDetails}
        heading="Please Update Your Venue Details:"
        Sidebar={AdminSidebar}
        buttons={buttons}
        buttonsForMenu={buttonsForMenu}
      />
    </>
  );
}

export default UpdateNightlifeVenueDetails;
